module.exports = __webpack_public_path__ + "img/pr-15.42eecd0e.png";